import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { trackMixpanelEvent } from 'utils/analytics';

import { useCreatePeriodicOperationUtils } from '@/modules/periodicTasks/components/Create/logic';
import { useCreateTechnicalOperationUtils } from '@/modules/workingDay/components/CreateTechnicalOperation/logic';
import { Button, Typography } from '@/shared/components/atoms';
import { useAuth } from '@/shared/hooks/context/auth';

import SprayerBlue from '~/images/shared/SprayerBlue.svg';
import Tree from '~/images/shared/TreeBlue.svg';

const CreateOperationSelector = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { openCreatePeriodicOperationModal } =
    useCreatePeriodicOperationUtils();
  const { openCreateTechnicalOperationModal } =
    useCreateTechnicalOperationUtils();

  const [selectedOperation, setSelectedOperation] = useState<
    'technical' | 'periodic' | undefined
  >(undefined);

  const activeClassNames = 'border-primary-80 rounded-2xl';
  const containerClassNames =
    'flex max-w-[165px] border-[3px] cursor-pointer flex-col items-center justify-center rounded-2xl bg-white p-16 text-center';

  const handleRedirection = async () => {
    trackMixpanelEvent('Create Periodic Operation - Home Page', user);
    if (selectedOperation === 'periodic') openCreatePeriodicOperationModal();
    if (selectedOperation === 'technical') openCreateTechnicalOperationModal();
  };

  return (
    <div className='mt-12'>
      <div className='flex gap-24'>
        <div
          className={classNames(
            containerClassNames,
            selectedOperation === 'technical'
              ? activeClassNames
              : 'border-background-transparent'
          )}
          onClick={() => setSelectedOperation('technical')}
        >
          <Tree width='24' height='24' />
          <Typography className='mt-16' weight='bold'>
            {t('technical')}
          </Typography>
          <Typography className='mt-4 text-surface-10' variant='caption'>
            {t('technical-operations-description')}
          </Typography>
        </div>
        <div
          className={classNames(
            containerClassNames,
            selectedOperation === 'periodic'
              ? activeClassNames
              : 'border-background-transparent'
          )}
          onClick={() => setSelectedOperation('periodic')}
        >
          <SprayerBlue width='24' height='24' />
          <Typography className='mt-16' weight='bold'>
            {t('periodic')}
          </Typography>
          <Typography className='mt-4 text-surface-10' variant='caption'>
            {t('periodic-operations-description')}
          </Typography>
        </div>
      </div>
      <Button
        disabled={!selectedOperation}
        onClick={handleRedirection}
        className='mt-32 h-56 !rounded-xl'
        size='full'
      >
        {t('next')}
      </Button>
    </div>
  );
};

export default CreateOperationSelector;
